module.exports = __webpack_public_path__ + "img/慢走丝1.0e9b00d2.jpg";